module.exports = __webpack_public_path__ + "static/media/video.0569bbfc.svg";